import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { navigationViews, UpdateService } from '../../../services/update.service';

@Component({
	selector: 'web-api',
	templateUrl: 'web-api.html',
	styleUrls: ['web-api.scss']
})
export class WebAPIHowToComponent implements OnInit {

	constructor(
		private _meta: Meta,
		private _updateService: UpdateService
	) {
		this._meta.updateTag({ name: 'description',
			content: 'CropManage is a crop management web application developed ' +
			'by UCANR which help farmers manage irrigation and fertilization scheduling.'})
	}

	ngOnInit(): void {
		this._updateService.setCurrentPage(navigationViews.API);
	}

	openLink(url: string) {
		window.open(url, '_blank');
	}
}
